import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';

const LINK_LIST = JSON.parse(localStorage.getItem('linkList')) || [
  { "name": "Google",
    "url": "https://www.google.com",
    "id": "QR-0"
  },
  { "name": "Github",
    "url": "https://www.github.com",
    "id": "QR-1"
  },
  { "name": "QR Tag",
    "url": "https://www.qrtag.net/api",
    "id": "QR-2"
  }
];

ReactDOM.render(<App links={LINK_LIST}/>,document.getElementById('root'));